"use strict";
/**
 * Reducer slice for `*_WORKFLOW*` actions.
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.workflowReducer = exports.isWorkflowAction = void 0;
var ai_hub_settings_client_ids_1 = require("./ai-hub-settings-client-ids");
var ai_hub_settings_utils_1 = require("./ai-hub-settings-utils");
var ai_hub_settings_reducer_helpers_1 = require("./ai-hub-settings-reducer-helpers");
exports.isWorkflowAction = function (action) {
    switch (action.type) {
        case 'ADD_WORKFLOW':
        case 'DELETE_WORKFLOW':
        case 'DISCARD_WORKFLOW_EDIT':
        case 'UPDATE_WORKFLOW_FIELD':
        case 'UPDATE_WORKFLOW_SYSTEMS':
        case 'SET_SELECTED_WORKFLOW':
            return true;
        default:
            return false;
    }
};
var addWorkflow = function (state) {
    var newWorkflow = ai_hub_settings_utils_1.createEmptyWorkflow();
    var newId = newWorkflow.__clientId;
    return __assign(__assign({}, state), { draft: __assign(__assign({}, state.draft), { workflows: __spreadArrays([newWorkflow], state.draft.workflows) }), newWorkflowIds: __spreadArrays([newId], state.newWorkflowIds), selectedWorkflowId: newId });
};
var deleteWorkflow = function (state, action) {
    var index = ai_hub_settings_client_ids_1.findWorkflowIndexById(state.draft.workflows, action.clientId);
    if (index < 0) {
        return state;
    }
    return __assign(__assign({}, state), { draft: __assign(__assign({}, state.draft), { workflows: ai_hub_settings_reducer_helpers_1.removeAt(state.draft.workflows, index) }), newWorkflowIds: state.newWorkflowIds.filter(function (id) { return id !== action.clientId; }), selectedWorkflowId: state.selectedWorkflowId === action.clientId ? null : state.selectedWorkflowId });
};
var discardWorkflowEdit = function (state, action) {
    var isNew = state.newWorkflowIds.indexOf(action.clientId) >= 0;
    var draftIndex = ai_hub_settings_client_ids_1.findWorkflowIndexById(state.draft.workflows, action.clientId);
    if (draftIndex < 0) {
        return state;
    }
    var clearSelection = state.selectedWorkflowId === action.clientId
        ? { selectedWorkflowId: null }
        : null;
    if (isNew) {
        return __assign(__assign(__assign({}, state), (clearSelection || {})), { draft: __assign(__assign({}, state.draft), { workflows: ai_hub_settings_reducer_helpers_1.removeAt(state.draft.workflows, draftIndex) }), newWorkflowIds: state.newWorkflowIds.filter(function (id) { return id !== action.clientId; }) });
    }
    var savedIndex = ai_hub_settings_client_ids_1.findWorkflowIndexById(state.saved.workflows, action.clientId);
    if (savedIndex < 0) {
        return state;
    }
    return __assign(__assign(__assign({}, state), (clearSelection || {})), { draft: ai_hub_settings_reducer_helpers_1.withWorkflowReplaced(state.draft, draftIndex, ai_hub_settings_utils_1.cloneAiHubSettingsWorkflow(state.saved.workflows[savedIndex])) });
};
var updateWorkflowField = function (state, action) {
    var _a;
    var index = ai_hub_settings_client_ids_1.findWorkflowIndexById(state.draft.workflows, action.clientId);
    if (index < 0) {
        return state;
    }
    return __assign(__assign({}, state), { draft: ai_hub_settings_reducer_helpers_1.withWorkflowReplaced(state.draft, index, __assign(__assign({}, state.draft.workflows[index]), (_a = {}, _a[action.key] = action.value, _a))) });
};
var updateWorkflowSystems = function (state, action) {
    var _a;
    var index = ai_hub_settings_client_ids_1.findWorkflowIndexById(state.draft.workflows, action.clientId);
    if (index < 0) {
        return state;
    }
    var next = __assign(__assign({}, state.draft.workflows[index]), (_a = {}, _a[action.role] = action.values, _a));
    return __assign(__assign({}, state), { draft: ai_hub_settings_reducer_helpers_1.withWorkflowReplaced(state.draft, index, next) });
};
exports.workflowReducer = function (state, action) {
    switch (action.type) {
        case 'SET_SELECTED_WORKFLOW':
            return state.selectedWorkflowId === action.clientId
                ? state
                : __assign(__assign({}, state), { selectedWorkflowId: action.clientId });
        case 'ADD_WORKFLOW':
            return addWorkflow(state);
        case 'DELETE_WORKFLOW':
            return deleteWorkflow(state, action);
        case 'DISCARD_WORKFLOW_EDIT':
            return discardWorkflowEdit(state, action);
        case 'UPDATE_WORKFLOW_FIELD':
            return updateWorkflowField(state, action);
        case 'UPDATE_WORKFLOW_SYSTEMS':
            return updateWorkflowSystems(state, action);
        default:
            return state;
    }
};
